import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,formStyles,dialog,details,grid,markdown } from '../../utilities/styles';
import { editIcon, deleteIcon,addIcon,close,clock,address,web,provisionIcon, yellowTick,expandIcon,collapseIcon,calendar } from '../../utilities/icons';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, getUrlFromFileId, validateURL, validatePhone, releaseFormLockwithBeacon } from '../../utilities/formsUtilities';
import { processProfileData } from '../../utilities/profileUtilities';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
import { handle403s } from '../../utilities/AllInErrorHandling';


export class AllInOrganisationSupportProfileForm extends AllInOrganisationConsumer(LitElement){
    static properties = {
        currentOrg: {type: String, reflect:true},
        name: { type: String },
        profile: { type: String },
        view: { type: String },
        _profileData: { state:true,type: Array },
        _isFormLocked: {state:true,type:Boolean},
        support_org_language_texts: { type: Object, state: true },
    }

    constructor() {
        super();
    }

    get _form(){
        return this.shadowRoot.querySelector('form');
    }

    get _modal(){
        return this.shadowRoot.querySelector('dialog');
    }

    async connectedCallback() {
        super.connectedCallback();
       
        if(!this.profile){
            this.formID = null;
        }
        else{
            this.formID = `${this.profile}-profile-form`;
        }
        this.uid = `profile-form-${this.organisationData.user.id}`;
        await this._setProfileData();
        //this.renderRoot.querySelector('a')?.focus();
        this.eventManager.listen(`allin-profile-go-back-${this.name}`,this._handleGoBack);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
        releaseFormLock(this.formID,this.uid,this.restUrl,this.nonce);
    }

    async firstUpdated(){
        if(this.formID){
            this._isFormLocked = await checkFormLock(this.formID,this.uid,this.restUrl,this.nonce);
            addEventListener('visibilitychange', (event) => {
                if (document.visibilityState === 'hidden') {
                    releaseFormLockwithBeacon(this.formID, this.uid, this.restUrl, this.nonce);
                } 
            });
        }
       
       
    }

    async updated(changedProperties){
        if(changedProperties.has('view')){
            if(this.view=='edit'){
                lockForm(this.formID,this.uid,this.restUrl,this.nonce);
                this.renderRoot.querySelector('input')?.focus();
            }
            else{
                this.renderRoot.querySelector('a')?.focus();
            }
            if(this.view){
                this.message = '';
            }
        }
    }
    /* <button id="zone" class="btn change_view ${this.view=='zone'?'active':''}" disabled aria-pressed="${this.view=='zone'?'true':'false'}">
        ${msg('Manage zones. Coming soon')}
    </button>  */
    render() {
        let main='';
        let navigation = html`<div class="buttons">
                <button id="${this.view=='edit'?'details':'edit'}" class="btn change_view ${!this.view||this.view=='edit'?'active':''}" @click=${this._handleChangeView } aria-pressed="${!this.view||this.view=='edit'?'true':'false'}">
                    ${msg('Support profile details')}
                </button>
                
                <button id="preview" class="btn change_view ${this.view=='preview'?'active':''}" @click=${this._handleChangeView} aria-pressed="${this.view=='preview'?'true':'false'}">
                    ${msg('Preview your support profile')}
                </button>
            </div>
            `;
        if(this.panel=='add'||this.view=='add'){
            navigation = '';
        }
        if(!this._profileDataProcessed||this._profileDataProcessed.length==0){
            main = html`<allin-loader loading></allin-loader>`;
        }
        else if(this.panel=='add'||this.view=='add'){
            main = this._getProfileForm('add',this._profileDataProcessed,navigation);
        }
        else if(this.panel=='edit'||this.view=='edit'){
            main = this._getProfileForm('edit',this._profileDataProcessed,navigation);
        }
        else if(this.panel=='preview'||this.view=='preview'){
            main = html`
                <h3>${decodeEntities(this._profileData.name)} ${msg(`details`)}</h3>
                ${navigation}
                <div class="preview--container">
                    <allin-support profile="${this._profileData.id}" hardlinks='${JSON.stringify(this.hardlinks)}' profileData="${JSON.stringify(this._profileData)}" organisationImage="${this.organisation.fileURL}" organisationImageAlt="${this.organisation.photoAltText}" preview="true" name="${this.name}" action="${this.action}" nonce="${this.nonce}" restUrl="${this.restUrl}"/>
                </div>
            `;
        }
        else if(this._profileData){
            let cta = html`<hr><a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}${msg(`Edit these details`)}</a>`; 
            let subHead = '';
            if(this._profileData.approvalStatus=='AwaitingResponse'){
                cta = html`
                    <hr>
                    <div class="message notice" aria-live="polite">
                        <p>${msg('You are waiting for approval on your recent change')}</p>
                    </div>
                    <a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}${msg(`Edit submission`)}</a>
                `
            }
            else if(this._profileData.approvalStatus=='NewApplication'){
                cta =html`<p><strong>${msg('Your application is being reviewed')}</strong></p>`;
            }
            else if(this._profileData.approvalStatus=='ChangesRequested'){
                cta = html`
                    <hr>
                    <div class="message error" aria-live="polite">
                        <p>${msg('Changes were requested on your recent submission. Please edit and resubmit.')}</p>
                        <h4>${msg('Changes:')}</h4>
                        <p>${this._profileData.declineMessage}</p>
                    </div>
                    <a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}${msg(`Edit submission`)}</a>
                `;
                subHead = html`<p>${msg('Changes were requested on your recent submission. Please edit and resubmit.')}</p>`;

            }
            if(!this._role=='ADMIN'&&!this._role=='MANAGER'){
                cta = '';
            }
            main = html`
                <h3>${msg(`Support profile details`)}</h3>
                ${navigation}
                ${subHead}
                <div class="bg">
                    <table>
                        <thead class="screen-reader-text">
                            <tr>
                                <th>Field</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${this._profileDataProcessed.map((item)=>{
                                if(item.type=='file'){
                                    return html`
                                        <tr class="field">
                                            <td>${item.title}</td>
                                            <td><img src="${this.organisation.fileURL}" alt="Organisation logo" width="200px" height="200px" style="object-fit:contain" /></td>
                                        </tr>
                                    `;
                                }
                                if(item.dependent){
                                    let dependency = this._accData.find((i)=>i.name==item.dependent.input);
                                    if(dependency && dependency.value!=dependency.dependency.value){
                                        return '';
                                    }
                                }
                                let value = item.value;
                                if(item.options){
                                    if (Array.isArray(item.value)) {
                                        value = item.value
                                            .map(selectedValue => {
                                                // If the selected value is an object, get its value/name
                                                const selected = typeof selectedValue === 'object'
                                                    ? (selectedValue.value ?? selectedValue.name)
                                                    : selectedValue;

                                                const option = item.options.find(i =>
                                                    i.value == selected || i.name == selected
                                                );

                                                return option?.label;
                                            })
                                            .filter(Boolean)
                                            .join(', ');
                                    }
                                    else if(item.name=='language'){
                                        value = item.options.find((i)=>i.name==item.value)?.label;
                                    }
                                    else{
                                        value = item.options.find((i)=>i.value==item.value)?.label;
                                    }
                                }
                                if(item.name=='description' && value){
                                    value = html`<allin-markdown-editor readonly value="${value}"></allin-markdown-editor>`;
                                }
                                return html`
                                <tr class="field ${item.options?'no-break':''}">
                                    <td>${item.title}</td>
                                    <td>${value}</td>
                                </tr>
                            `
                            })}    
                        </tbody>              
                    </table>
                    ${cta}   
                </div>
            `;
        }
        else{
            main = html`<allin-loader loading></allin-loader>`;
        }
        return html`${main}`;
    }

    _handleClick(e){
        e.preventDefault();
        this.view = this.view=='edit'?'':'edit';
    }

    _handleGoBack(){
        this._handleChangeView(null,'');
    }

    _handleChangeView(e,view=null){
        if(e){
            e.preventDefault();
            
            let button = e.target;
            view = button.id;
            if(view=='edit'){
                view = '';
            }
        }
        let oldView = this.view;
        this.view = view;
        if(this.view==oldView){
            return;
        }
        this.eventManager.addHistory('/organisation-dashboard/'+this.currentOrg+'/support/'+this._profileData.type+'/'+this.view,{panel:this.event,view:this.view});
        if(this.view){
            let name = '';
            if(this.view=='zone'){
                name = msg(str`Manage zones for ${this._locationData.name}`);
                if(oldView=='preview'){
                    this.eventManager.emit(`allin-navigation-reset-${this.name}`,{});
                }
            }
            else if(this.view=='preview'){
                name = msg(str`Listing view`);
            }
            let crumb = {
                organisation:{url:`/organisation-dashboard/${this.currentOrg}/`,title:msg(str`${this.organisation?.name}`)},
                dashboard:{url:`/organisation-dashboard/${this.currentOrg}/support/`,title:msg(`Support profiles`)},
                panel:{url:`/organisation-dashboard/${this.currentOrg}/support/${this._profileData.type}/${this.view}`,title:name}
            }
            this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
        }
    }
    
    _getProfileForm(view,profileData,navigation=''){
        let main;
        if(this._profileData&&this._isFormLocked){
            main = html`
                <h3>${decodeEntities(profileData.name)} ${msg(`details`)}</h3>
                ${navigation}
                <div class="bg">
                    <div class="message notice" aria-live="polite">
                        <p>${msg('This form is currently being edited by another member of this organisation')}</p>
                    </div>
                </div>
            `;
        }    
        else{
            let title = view=='add'?msg('Add a new profile'):`${msg('Edit profile')} ${decodeEntities(this._profileData.name)}`
            main=html`
                <h3>${title}</h3>
                ${navigation}
                <form @submit=${this._handleSubmit}>
                    <div class="message notice" aria-live="polite">
                    </div>
                    <div class="bg">
                        
                            ${this._profileDataProcessed.map((item)=>{

                                
                                let input='';
                                if(item.type=='file'){
                                    return html`
                                        <div class="input-group">
                                            <allin-image-uploader inputname="org_logo" labelalt="${msg('Organisation logo')}" label ="${msg('Upload an organisation logo')}" src="${this.organisation.fileURL}">
                                            </allin-image-uploader>
                                            <p>This is linked to the logo of your organisation.</p>
                                        </div>`;
                                }
                                if(item.type=='checkbox'){
                                    input = html`<input type="${item.type}" id="${item.name}" name="${item.name}" ?checked=${item.value} />`;
                                }
                                else if(item.type=='multiselect'){
                                    input = html`<allin-multiselect name='${item.name}' list='${JSON.stringify(item.options)}' value='${JSON.stringify(item.value)}' required data-error_message="${item.error_message?item.error_message:item.label + 'is required'}"></allin-multiselect>`;
                                }
                                else if(item.type=='textarea'){
                                    //input = html`<textarea name="${item.name}" id="${item.name}" data-label="${item.title}" data-table_label="Description" maxlength="500" placeholder="${msg(`Description`)}">${decodeEntities(item.value)}</textarea>`; 
                                    input = html`<allin-markdown-editor name="${item.name}" id="${item.name}" data-label="${item.labelalt}" labelalt="${item.title}" description="${msg(`Description`)}" maxlength="500" placeholder="${msg(`Description`)}" value="${decodeEntities(item.value)}" ?required="${item.required}" data-error_message="${item.error_message?item.error_message:item.label + 'is required'}"></allin-markdown-editor>`;
                                }
                                else if(item.type=='select'){
                                        input = html`<select name="${item.name}" id="${item.name}" data-label="${item.title}" data-table_label="${item.title}" ${item.hasOwnProperty('required')?'aria-required="true"':''} data-error_message="${item.error_message?item.error_message:item.label + 'is required'}">
                                            ${item.name!=='language'? html`<option value="">${msg(`Please select`)}</option>` : ''}
                                            ${item.options.map((option)=>{ return html`<option value="${option.name}" ?selected=${option.name===item.value}>${option.label}</option>`; })}
                                        </select>`;
                                }
                                
                                else if(item.type=='number'){
                                    
                                    input = html`<input type="${item.type}" id="${item.name}" name="${item.name}" value=${parseFloat(item.value)} min="0.00" step="any" ${item.hasOwnProperty('required')?'aria-required="true"':''} />`;
                                }
                                else if(item.hasOwnProperty('required')){
                                    input = html`<input @change=${this._validateURL} type="${item.type}" id="${item.name}" aria-required="true" name="${item.name}" value=${decodeEntities(item.value)} data-error_message="${item.error_message?item.error_message:item.label + 'is required'}" />`;
                                }
                                else{  
                                    input = html`<input @change=${this._validateURL} type="${item.type}" id="${item.name}" name="${item.name}" value=${decodeEntities(item.value)} data-requiredif="${item.requiredIf}" />`; 
                                }   
                                return html`
                                <div class="input-group" aria-live="polite">
                                    <label for="${item.name}">${item.title}${item.hasOwnProperty('required') ? '*' : ''}</label>
                                    ${item.description?html`<p class="small">${item.description}</p>`:''}
                                    ${input}
                                </div>
                            `
                            })} 
                            <input type="hidden" name="org_id" value="${this.currentOrg}" />
                            ${this._profileData && html`<input type="hidden" name="profile_id" value="${this._profileData.id}" />`}
                            <input type="hidden" name="action" value="${this.action}-edit-support-profile" />
                            <div class="button-group">
                                <button type="submit">${msg(`Submit`)}</button>
                            </div>   
                            <hr>
                            <a href="javascript:void(0)" @click=${this._handleClick}>${deleteIcon}${msg(`Cancel`)}</a>
                    </div>
                </form> 
            `;
        }
        return main;
    }
    async _handleSubmit(e){
        e.preventDefault();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('[type="submit"]');

 
        let valid = validateForm(this._form,formResponse);
        if(!valid){ 
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        //formData = JSON.stringify(Object.fromEntries(formData));
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try{
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })

            if(response.status === 403){
                handle403s();
                return;
            }

            response = await response.json();
            if(!response.error){
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                let profileData = response.profiles;
                if(typeof profileData=='string'){
                    profileData = JSON.parse(profileData);
                }
                this.organisation.profiles = profileData;
                await this._setProfileData();
                submitButton.disabled = false; 
                if(this.panel=='add'){
                    this.message = msg('Your support profile has been created. You can manage your support profile from your organisation dashboard');
                }
                else{
                    this.message = msg('Your changes have been saved');
                }
                this.panel = '';
                this._updateContext({organisation:this.organisation,panel:this.panel});
               
            }
            else{
                formResponse.innerHTML = response.message || 'An error occurred';
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false; 
            }
        }
        catch(error){
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        };
    }

    async _setProfileData(){
        this._profileData = this.organisation.profiles.find(profile=>profile.type=='support');
        this._profileDataProcessed = processProfileData(this._profileData, this.support_org_language_texts);
    }

    _getOrganisationById(id){
        return this.organisations.find((org)=>org.org_id==id);
    }

   
    _handleContextUpdate(value){
        this.organisationData = value;
        ({currentOrg:this.currentOrg,name:this.name,restUrl:this.restUrl,nonce:this.nonce,provisions:this._provisions, support_org_language_texts:this.support_org_language_texts} = this.organisationData);        
    }


    _expandCollapseAll(e){
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if(e.currentTarget.classList.contains('expand_all')){
            targets.forEach(target=>{
                target.setAttribute('open','');
            });
        }
        else{
            targets.forEach(target=>{
                target.removeAttribute('open');
            });
        }
    }

    _handleCollapse(e){
        let target = e.currentTarget.dataset.collapse;
        if(target){
            let targets= this.shadowRoot.querySelectorAll(`.${target}`);
            if(e.currentTarget.getAttribute('aria-expanded')=='true'){
                e.currentTarget.setAttribute('aria-expanded','false');
                targets.forEach(target=>target.classList.remove('open'));
            }
            else{
                e.currentTarget.setAttribute('aria-expanded','true');
                targets.forEach(target=>target.classList.add('open'));
            }
        }
    }

    _validateURL(e){
        if(e.target.type!=='url') return;
        validateURL(e.target);
    }

    _slotURLChangeOnline(e) {
        const value = e.target.value?.trim();
        if (value && !/^https?:\/\//i.test(value)) {
            e.target.value = `https://${value}`;
        }
    }

    // New custom function to get Online event link data to be passed to allin-navigation
    _getSidebarLinks() {
        const links = [];

        // Online access link (only for Online events)
        if (this.eventIsOnline) {
            let accessLink = this._eventDataProcessed.find(item => item.name === 'locationUrl');
            if (accessLink) {
                accessLink.value = decodeEntities(this._eventData?.locationUrl ?? '');
                if (accessLink.value) {
                    links.push({ label: 'Online access link', url: accessLink.value });
                }
            }
        }

        return links;
    }


    static styles = [
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        markdown,
        css`
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .bg a:hover{
            text-decoration:underline;
        }



        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {

            .button-group button:hover svg, .return:hover svg{
                transform:none;
            }
        }
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child:not(.duet-date__cell){
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
                background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
                font-weight: var(--allin-button-font-weight, 600);
                color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            max-height:0;
            overflow:hidden;
            transition:all var(--transition) ease;
            transition-behavior: allow-discrete;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            max-height:700px;
            box-sizing: border-box;
            overflow:visible;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        .add_uploader{
            background-color: var(--allin-button-bg-color, #472961);
            color: #fff;
            margin-bottom: 1.5rem;
        }
        .add_uploader span svg {
            background-color: #fff;
            transform: translate(0px, 3px);
        }

        .add_uploader:hover span svg {
            background-color: transparent;
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-size:clamp(1.25rem, 5cqw, 1.5rem);
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        .instances{
            padding:0;
            margin:0;
            list-style:none;
        }

        .instances li:not(:last-child){
            margin-bottom:1rem;
            padding-bottom:1rem;
            border-bottom:1px solid var(--allin-highlight-color,#472961);
        }

        .instances dl{
            display:grid;
            grid-template-columns: max-content 1fr;
            gap:1rem;
        }

        .instances dl dt{
            font-weight:500;
        }
        
        dd h4{
            margin:0 0 0.5rem 0;
        }

        dd p{
            margin-bottom:1rem;
        }
        p:has(+.provisions){
            grid-column: 1 / -1;
            margin-top:2rem;
            margin-bottom:0;
        }
        .repeater{
            padding:0 2rem;
        }
        allin-location-search .bg{
            background-color:var(--color-bg);
        }
        allin-location-search ul{
            list-style:none;
            padding:0;
            margin:1rem 0;
        }
        allin-location-search li, allin-location-search .selected-location{
            margin-bottom:0.5rem;
            display:grid;
            grid-template-columns: 3rem 1fr auto;
            gap:1rem;
            align-items:center;
            img{
                width:3rem;
                height:3rem;
                object-fit:cover;
            }
            button{
                height:fit-content;
            }
        }
        .searchboxes {
            display: grid;
            grid-template-columns: 1fr auto;
            width: 100%;
            max-width: 800px;
            margin-bottom: 2rem;
            position:relative;
        }

        .searchbox {
            position: relative;
            label {
                margin-bottom: 0.5rem;
            }
        }
        .searchbox svg {
            position: absolute;
            left: 0.5rem;
            bottom: 0.8rem;
            width: 1.5rem;
            height: 1.5rem;
        }

        .searchbox input{
            padding-left:2.5rem;
            border-radius:0.5rem 0 0 0.5rem;
        }
        .searchboxes button{
            border-radius:0 0.5rem 0.5rem 0;
            height:calc(3rem + 2px);
            align-self:end;
        }
        .no-location button{
            margin:1rem 0 0 auto;
            display:block;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }

        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }

        .no-break td{
            word-break: keep-all;
        }
        `
        ];
        
}